<template>
  <div>
    <div class="form-group mb-2">
      <label class="form-label">оператор</label>
      <input type="text" v-model="operator" class="form-control" />
    </div>
    <div class="form-group mb-2">
      <label class="form-label">транк</label>
      <input type="text" v-model="trank_name" class="form-control" />
    </div>
    <div class="d-flex flex-row justify-content-end">
      <a href="javascript:void(0)" class="btn btn-sm btn-outline-primary" @click="confirm">добавить</a>
    </div>
  </div>
</template>

<script>
export default {
  props: { onConfirm: { type: Function } },
  data() {
    return {
      operator: '',
      trank_name: '',
    }
  },
  methods: {
    confirm() {
      const op = (this.operator || '').trim();
      const tr = (this.trank_name || '').trim();
      if (!op || !tr) { return; }
      if (typeof this.$props.onConfirm === 'function') {
        this.$props.onConfirm({ operator: op, trank_name: tr });
      }
    }
  }
}
</script>


